import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ISurveyors } from "app/models/core/admin/surveyors";
import { IKey, Keys, Misc } from "app/models/core/keys";
import { ISurveyReport } from "app/models/core/reports/surveyReport";
import { AdminService } from "app/services/admin/admin.service";
import { SharedService } from "app/services/core/shared.service";
import { ReportsService } from "app/services/reports/reports.service";


@Component({
  selector: 'app-surveyReports',
  templateUrl: './surveyReports.component.html',
  styleUrls: ['./surveyReports.component.scss'],
})

export class SurveyReportsComponent implements OnInit {

  months = Misc.months;
  years = Misc.years;
  mon = 0;
  yr = 0;
  type = '';
  surveyTypes: IKey[] = Keys.surveyType;
  surveyorList: ISurveyors[] = [];

  list: ISurveyReport[] = [];

  reportMode = 'none';

  reportGroup = new UntypedFormGroup({
    SurveyType: new UntypedFormControl(''),
    Month0: new UntypedFormControl(''),
    Year0: new UntypedFormControl(''),
    Surveyor0: new UntypedFormControl(''),

    Type3: new UntypedFormControl(''),
    Surveyor3: new UntypedFormControl(''),
    Month3_0: new UntypedFormControl(''),
    Year3_0: new UntypedFormControl(''),
    Month3_1: new UntypedFormControl(''),
    Year3_1: new UntypedFormControl(''),

    Month4_0: new UntypedFormControl(''),
    Year4_0: new UntypedFormControl(''),
    Month4_1: new UntypedFormControl(''),
    Year4_1: new UntypedFormControl(''),
  });

  surveyColumns: string[] = ['stateNumber', 'cliaNumber', 'labName', 'city', 'surveyDate',
    'type', 'fuDue', 'fuDone', 'deficiencies', 'surveyors', 'conditionLevel', 'paid'
  ];

  followupColumns: string[] = ['stateNumber', 'cliaNumber', 'labName', 'city', 'address', 'surveyDate',
    'type', 'fuDue', 'fuDone','hoursOnSite', 'deficiencies', 'surveyors', 'paid'
  ];

  registrationColumns: string[] = ['stateNumber', 'labName', 'city', 'address',
    'cliaExpirationDate', 'cliaNumber', 'paid', 'lastSurveyDate', 'surveyAfterDate'
  ];

  deficiencyColumns: string[] = ['deficiency', 'zeroFourth', 'oneFourth', 'twoFourth', 'threeFourth',
    'fourFourth', 'averagePercent', 'numTotal'
  ];

  unresolvedDeficienciesColumns: string[] = ['surveyDate', 'labId', 'labName', 'deficiency', 'sod',
    'poc', 'inspector1', 'inspector2'
  ];

  dataSource = new MatTableDataSource<ISurveyReport>(this.list);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;



  constructor(public reportsService: ReportsService,
    public sharedService: SharedService,
    private adminService: AdminService) { };

  ngOnInit(): void {

    this.reportsService.currentTab = 0;
    this.adminService.getSurveyors().subscribe(
      res => {
        this.surveyorList = res;
      },
      error => console.log('error: ', error),
      () => { }
    );

    let now = new Date()
    let month = (now.getMonth() + 1).toString();
    let year = now.getFullYear().toString();
    this.reportGroup.patchValue({
      SurveyType: 'All',
      Month0: month,
      Year0: year,
      Surveyor0: 'Everyone',

      Type3: 'POC',
      Surveyor3: 'All',
      Month3_0: month,
      Year3_0: year,
      Month3_1: month,
      Year3_1: year,

      Month4_0: month,
      Year4_0: year,
      Month4_1: month,
      Year4_1: year,
    });
  }

  surveyReport() {
    this.mon = this.reportGroup.controls['Month0'].value;
    this.yr = this.reportGroup.controls['Year0'].value;
    let type = this.reportGroup.controls['SurveyType'].value;
    let sur = this.reportGroup.controls['Surveyor0'].value;
    this.reportsService.getSurveyReport(type, this.mon.toString(), this.yr.toString(), sur).subscribe(
      res => {
        this.list = res;
        this.dataSource.data = this.list;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.reportMode = 'survey';
      },
      error => console.log('error', error),
      () => {
      }
    );
  }

  followupReport() {
    this.reportsService.followUpDoneReport().subscribe(
      res => {
        this.list = res;
        this.dataSource.data = this.list;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.reportMode = 'followup';
      },
      error => console.log('error', error),
      () => {
      }
    );
  }

  registrationReport() {
    this.reportsService.registrationLabsReport().subscribe(
      res => {
        this.list = res;
        this.dataSource.data = this.list;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.reportMode = 'registration';
      },
      error => console.log('error', error),
      () => {
      }
    );
  }

  deficiencyReport() {
    let mon1 = this.reportGroup.controls['Month3_0'].value;
    let yr1 = this.reportGroup.controls['Year3_0'].value;
    let mon2 = this.reportGroup.controls['Month3_1'].value;
    let yr2 = this.reportGroup.controls['Year3_1'].value;
    let surv = this.reportGroup.controls['Surveyor3'].value;
    this.type = this.reportGroup.controls['Type3'].value;
    this.reportsService.deficiencyReport(surv, this.type, mon1, yr1, mon2, yr2).subscribe(
      res => {
        this.list = res;
        this.dataSource.data = this.list;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.reportMode = 'deficiency';
      },
      error => console.log('error', error),
      () => {
      }
    );
  }

  unresolvedDeficienciesReport() {
    let mon1 = this.reportGroup.controls['Month4_0'].value;
    let yr1 = this.reportGroup.controls['Year4_0'].value;
    let mon2 = this.reportGroup.controls['Month4_1'].value;
    let yr2 = this.reportGroup.controls['Year4_1'].value;
    this.reportsService.deficiencyUnresolvedReport(mon1, yr1, mon2, yr2).subscribe(
      res => {
        this.list = res;
        this.dataSource.data = this.list;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.reportMode = 'unresolvedDeficiencies';
      },
      error => console.log('error', error),
      () => {
      }
    );
  }

  csv(mode: string) {
    let fileName = 'SurveyReport.csv';
    if (mode == 'followup') {
      fileName = 'FollowupReport.csv';
    }
    else if (mode == 'registration') {
      fileName = 'RegistrationReport.csv';
    }
    else if (mode == 'deficiency') {
      fileName = 'DeficiencyReport.csv';
    }
    else if (mode == 'unresolvedDeficiencies') {
      fileName = 'UnresolvedDeficienciesReport.csv';
    }

    this.sharedService.exportToCsv(fileName, this.list);
  }

  tabVisible(type: string): boolean {
    // TODO
    return true;
  }

}
